import React from "react";

export default class Td extends React.Component {
  render() {
    return <td>{this.props.children}</td>;
  }
}
